import { render } from "./LanguageBlock.vue?vue&type=template&id=77a6ed96&scoped=true"
import script from "./LanguageBlock.vue?vue&type=script&lang=ts"
export * from "./LanguageBlock.vue?vue&type=script&lang=ts"

import "./LanguageBlock.vue?vue&type=style&index=0&id=77a6ed96&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-77a6ed96"

export default script